const MAX_FIRST_NAME = 17;
const MAX_LAST_NAME = 22;
export const NAVIGATE_TO_CAM_DASHBOARD_MOBILE = '/account/dashboard';
export const NAVIGATE_TO_CAM_DASHBOARD_DESKTOP = '/account/dashboard';
export const paymentMethodTypeIconMap = {
    'AMERICAN EXPRESS': 'american-express.svg',
    DISCOVER: 'discover.svg',
    AMEX: 'american-express.svg',
    'JCPENNEY MASTERCARD': 'jcpmastercard.svg',
    JCP: 'jcp-plcc.svg',
    'MASTER CARD': 'mastercard.svg',
    MASTERCARD: 'mastercard.svg',
    PAYPAL: 'paypal.svg',
    VISA: 'visa.svg',
    DUALCARD: 'jcpmastercard.svg',
    DEFAULT: 'neutral.svg',
};

export const ORDER_DETAILS_FETCH_CARD_TYPE_MAP = {
    AMEX: 'AMERICAN_EXPRESS',
    DISCOVER: 'DISCOVER',
    JCP: 'JCP_CARD',
    JCPMASTER: 'JCPENNY_MASTER_CARD',
    MASTER: 'MASTER_CARD',
    VISA: 'VISA',
};
export const ORDER_DETAILS_FETCH_EMAILABLE_CARE_PLAN_SUB_DIVISIONS = [
    '090',
    '117',
    '209',
    '683',
    '780',
    '864',
    '869',
    '076',
];
export const ORDER_DETAILS_FETCH_MAILABLE_CARE_PLAN_SUB_DIVISIONS = ['098'];
export const ORDER_DETAILS_FETCH_DELIVERY_PROMISE_MESSAGE_DESCRIPTION = {
    'Pickup Interval': 'Pickup: % s - % s',
    'Est Delivery Interval': 'Est.Delivery: % s - % s',
    'Est Delivery Date': 'Est.Delivery: % s',
    'Selected Delivery Date': 'Selected Delivery Date: % s',
    'Pickup Soon': 'THESE ITEMS WILL BE AVAILABLE FOR PICK UP IN 4 TO 7 BUSINESS DAYS.',
    'Email Care Plan': 'Care plan provider will email protection plan(s)',
    'Mail Protection Plan': 'Care plan provider will mail protection plan(s) to the address',
};
export const ORDER_DETAILS_FETCH_DELIVERY_PROMISE_STATUS = {
    Backordered: 'Backordered',
    Cancelled: 'Canceled',
    Delivered: 'Delivered',
    'In Process': 'In Progress',
    'In process': 'In Progress',
    'Transfer in Process': 'In Progress',
    'Pending fulfillment': 'In Progress',
    'Released to Fulfillment': 'In Progress',
    Picked: 'In Progress',
    Packed: 'In Progress',
    Shipped: 'Shipped',
    'Ready for Customer Pick': 'Ready for Pickup',
    'Picked by Customer': 'Picked Up',
    'Return Created': 'Returned',
    'Shipped to Store': 'Shipped to Store',
    'Post Invoice Cancel': 'Canceled',
    'Picked up Date': 'Picked Up: % s',
    'Picked up': 'Picked Up',
    'In Progress': 'In Progress',
    Returned: 'Returned',
    'Ready for Pickup': 'Ready for Pickup',
};
export const ORDER_DETAILS_FETCH_BACK_ORDER_ITEM_STATUS = ['Back Order', 'BO WOH', 'Backordered'];
export const ORDER_DETAILS_FETCH_CANCELLED_ITEM_STATUS = [
    'Back Order Cancel',
    'Canceled',
    'Cancelled',
];
export const ORDER_DETAILS_FETCH_NOT_AVAILABLE_ITEM_STATUS = [
    'Not Available',
    'Partial Available',
    'Partial Back Order',
    'Partial Discontinue',
    'Partial Track Order',
    'TO',
    'Discontinued',
    'No Process',
    'Dropped',
    'TO Recorder',
    'Back Order Delete',
    'Error',
];
export const ORDER_DETAILS_FETCH_FACTORY_SHIP_ITEM_STATUS = [
    'Factory Ship Supplier Cancel',
    'Factroy Ship Customer Cancel',
    'Factory Ship Release',
    'Factory Ship',
];
export const ORDER_DETAILS_FETCH_LARGE_APPLIANCE_ITEMS = [
    'largeAppliance',
    'LARGEAPPLIANCEINSTALL',
    'LARGEAPPLIANCESERVICE',
    'LARGEAPPLIANCEPARTS',
];
export const ORDER_DETAILS_FETCH_PROTECTION_PLAN_AND_SERVICE_ITEMS = [
    'SERVICE',
    'LARGEAPPLIANCEINSTALL',
    'LARGEAPPLIANCEPARTS',
];
export const ORDER_DETAILS_FETCH_PRICE_TYPES = [
    'PRICEQUOTE',
    'ORIGINAL',
    'ACTIVE',
    'CLEARANCE',
    'SALE',
    'FORCEDPRICE',
];
export const ORDER_DETAILS_FETCH_CHARGE_TYPES = [
    'TAX',
    'OVERSIZED SURCHARGE',
    'SHIPPING AND HANDLING',
    'GIFTWRAP',
    'RECYCLE CHARGE',
    'ROUND UP CHARITY',
];
export const ORDER_DETAILS_FETCH_DISCOUNT_TYPES = [
    'COUPON',
    'REWARDSCERT',
    'ENTERPRISE',
    'ASSOCIATEDISCOUNT',
    'SHIPPING',
    'MISCELLANEOUS',
];
export const ORDER_DETAILS_FETCH_ROUND_UP_CHARITY_LOT_NUMBERS = ['1712000'];
export const ORDER_DETAILS_FETCH_RECYCLE_FEE_LOT_NUMBERS = ['713'];
export const ORDER_DETAILS_FETCH_RETAIL_DELIVERY_FEE_LOT_NUMBERS = ['24601000018'];
export const navigateToSignIn = {
    mobile: '/signin',
    desktop: '/signin',
};
export const navigateToHome = {
    mobile: '/',
    desktop: '/',
};
export const CREATE_ACCOUNT_NAME = /^[a-zA-Z\s0-9]*$/;
export const CREATE_ACCOUNT_UPPER_CHAR_REG_EXP = /[A-Z]/;
export const CREATE_ACCOUNT_LOWER_CHAR_REG_EXP = /[a-z]/;
export const CREATE_ACCOUNT_NUMBER_REG_EXP = /\d/;
export const CREATE_ACCOUNT_BIRTHDAY = /^[0-9/]{1,5}$/;
export const CREATE_ACCOUNT_PHONE_NUMBER = /^\d{10}$/;
export const CREATE_ACCOUNT_PHONE_NUMBER_REGX = /^[0-9]*$/;
export const CREATE_ACCOUNT_BIRTHDAY_REGX = /^(((0)[1-9])|((1)[0-2]))(\/)((0)[1-9]|[1-2][0-9]|(3)[0-1])$/;
export const CREATE_ACCOUNT_MAX_FIRST_NAME = MAX_FIRST_NAME;
export const CREATE_ACCOUNT_MAX_LAST_NAME = MAX_LAST_NAME;
export const CREATE_ACCOUNT_MORE_THAN_TWO_CONSECUTIVE_CHARS_REG_EXP = /(.)\1\1/;
export const CREATE_ACCOUNT_FIRST_NAME_REGX = /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{2})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{1,17}$/;
export const CREATE_ACCOUNT_LAST_NAME_REGX = /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{3})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{2,22}$/;
// export const CREATE_ACCOUNT_SPECIAL_CHARS_REG_EXP = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/;
export const CREATE_ACCOUNT_INVALID_PHONE_NUMBER = 'Please enter a valid Phone Number';
export const CREATE_ACCOUNT_INFO_ICON_NAME = 'information';
export const CREATE_ACCOUNT_LOYOLTY_INVALID_TOKEN_ERROR_CODE = 'LOYALTY_INVALID_TOKEN';
export const SIGNIN_EMAIL_REG_EXP = /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9]+)*@[A-Za-z0-9]+([_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
export const SIGNIN_EMPTY_EMAIL_ERROR_MESSAGE = 'Please enter a valid email address';
export const SIGNIN_LONG_EMAIL_ERROR_MESSAGE = 'Email should contain not more than 70 characters.';
export const SIGNIN_EMPTY_PASSWORD_ERROR_MESSAGE = 'Enter a valid password';
export const SIGNIN_CAPTCHA_ERROR_TYPE = 'ERROR_TYPE_CAPTCHA';
export const SIGNIN_CAPTCHA_NOT_CHECKED = 'Enter captcha';
export const SIGNIN_ERROR_TYPE_EMAIL = 'ERROR_TYPE_EMAIL';
export const SIGNIN_ERROR_TYPE_PASSWORD = 'ERROR_TYPE_PASSWORD';
export const SIGNIN_ERROR_TYPE_EMAIL_AND_PASSWORD = 'ERROR_TYPE_EMAIL_PASSWORD';
export const SIGNIN_GENERAL_ERROR_MESSAGE = 'Please correct the errors listed in red below';
export const SIGNIN_REMEBER_ME_EXPIRE_DAYS = 365;
export const SIGNIN_JCP_SIGNIN_COOKIE = 'JCPSignInCookie';
export const SIGNIN_SVC_USR_ERR_PROFILE_LOCKED = 'SVC_USR_ERR_PROFILE_LOCKED';
export const SIGNIN_SRV_PROFILE_LOCKED = 'SRV_PROFILE_LOCKED';
export const SIGNIN_PROFILE_LOCKED_ERROR_MESSAGE =
    'You have reached the max number of login attempts. For your protection, this jcp.com account has been locked. You will receive an email shortly to reset your password.';
export const SIGNIN_SRV_CUSTOMER_NOT_FOUND = 'SRV_CUSTOMER_NOTFOUND';
export const SIGNIN_SRV_CUSTOMER_NOT_FOUND_MESSAGE =
    'The email address or password you entered was not found in our records. Remember, your password is case sensitive. Please try again.';
export const SIGNIN_ERR_CODE_LAST_ATTEMPT = 'SVC_USR_ERR_PROFILE_ACCOUNT_LAST_ATTEMPT';
export const SIGNIN_SRV_CAPTCHA_NOT_FOUND = 'SRV_INVALID_CAPTCHA_REQUEST';
export const SIGNIN_SRV_CAPTCHA_INVALID = 'SRV_GC_CAPTCHA_INVALID';
export const SIGNIN_SRV_CAPTCHA_NOT_FOUND_MESSAGE =
    'You have only one more attempt to login before the account gets locked.';
export const SIGNIN_REQUEST_FAILED_MESSAGE =
    'We’re having trouble completing your request. Try again.';
export const PLACEHOLDER_PASSWORD = 'Password';
export const PLACEHOLDER_NEW_PASSWORD = 'New Password';
export const termsAndConditionsLink =
    'http://www.jcpenney.com/m/rewards-terms-and-conditions?pageId=pg40067700009';
export const DP_USER_STATE = 'DP_USER_STATE';
export const DP_REWARDS_CERTS = 'DP_REWARDS_CERTS';

const Constants = {
    barcode: {
        modalTitle: 'Use Your Rewards',
        modalHeading:
            'To Redeem in-store, present barcode to the cashier. Some <a href="www.jcpenney.com">exclusions</a> may apply.',
        modalButtonTitle: 'Print',
        type: {
            JCPMASTER: ['MCCERT', 'MASTERCARD RWD'],
        },
        images: {
            MASTERCARD: '/static-account/assets/images/mc-vrt-pos.svg',
            BONUSBUCKS: '/static-account/assets/images/bonus-bucks-cert-header.svg',
            BG_LG_BONUSBUCKS: '/static-account/assets/images/bonus-bucks-bg-xl.svg',
        },
    },
    navigateToRewardsHome: {
        mobile: '/rewards',
        desktop: '/rewards',
    },

    cardTypeMap: {
        amex: /^3[47]|^3([8]{10})|^3([9]{10})/,
        visa: /^(4[0-9]).{10}.*$/,
        discover: /^(?:6(?:011|5[0-9][0-9]|4[4-9])[0-9]{8})|^6[8]{10}|^6[9]{10}.*$/,
        dualcard: /(^546680.{6}|^(78|79).{10}).*$/,
        jcpmaster: /(^546680.{6}|^(78|79).{10}).*$/,
        mastercard: /^(5[1-5]).{10}|^5([8]{10})|^5([9]{10}).*$/,
        jcp: /^\d{11}$|^\d{16}$/,
    },
    impulseCardTypeMap: {
        'AMERICAN EXPRESS': /^3[47]|^3([8]{10})|^3([9]{10})/,
        VISA: /^(4[0-9]).{10}.*$/,
        DISCOVER: /^(?:6(?:011|5[0-9][0-9]|4[4-9])[0-9]{8})|^6[8]{10}|^6[9]{10}.*$/,
        'JCPENNEY MASTERCARD': /(^546680.{6}|^(78|79).{10}).*$/,
        'MASTER CARD': /^(5[1-5]).{10}|^5([8]{10})|^5([9]{10}).*$/,
        JCP: /^\d{11}$|^\d{16}$/,
    },
    ACCOUNT_ID: 'ACCOUNT_ID',
    DP_FIRST_NAME: 'DP_FIRST_NAME',
    DP_REWARDS_STATUS: 'DP_REWARDS_STATUS',
    cvv: {
        label: 'CVN',
    },

    confirmCreateAccount: {
        title: 'Confirm Your Account',
        message: 'A confirmation email has been sent to ',
        spamCheckMsg: 'Make sure to check your spam folder.',
    },
    keepMeLoggedIn: {
        title: 'Keep me signed in',
        helpMessage: 'Uncheck the box if this is a shared device.',
    },

    navigateToCreateAccount: {
        mobile: '/createaccount',
        desktop: '/createaccount',
    },
    trackOrder: {
        inputFields: {
            orderNumber: {
                defaultError: 'Please enter a valid order number',
                label: 'Order Number',
                type: 'text',
                name: 'orderNumber',
                onlyNum: /[^\d]/g,
            },
            phoneNumber: {
                defaultError: 'Please enter a valid phone number',
                label: 'Phone Number',
                placeholder: '( ___ ) ___ - ____ ',
                name: 'phoneNumber',
            },
        },
    },
};

export default Constants;
